import { render, staticRenderFns } from "./CheckoutStepCart.vue?vue&type=template&id=39b245c4&"
import script from "./CheckoutStepCart.vue?vue&type=script&lang=js&"
export * from "./CheckoutStepCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports